import { render } from "./SocialComponent.vue?vue&type=template&id=4bb8420d&scoped=true"
const script = {}

import "./SocialComponent.vue?vue&type=style&index=0&id=4bb8420d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb8420d"]])

export default __exports__